import { useRouter } from 'next/router';

/**
 * Get the value of an optional Next.js dynamic route parameter.
 *
 * @example ```ts
 * // Inside pages/[id].tsx
 *
 * const id = useOptionalRouteParam('id');
 * // typeof id === 'string' | 'undefined'
 *
 * const idWithDefault = useOptionalRouteParam('id', 'default');
 * // typeof idWithDefault === 'string'
 * ```
 */
export function useOptionalRouteParam(param: string): string | undefined;
export function useOptionalRouteParam(
  param: string,
  defaultValue: string,
): string;
export function useOptionalRouteParam(param: string, defaultValue?: string) {
  const { query } = useRouter();

  const value = query?.[param];

  if (typeof value === 'string') {
    return value;
  }

  return defaultValue;
}
